module.exports = __webpack_public_path__ + "portal-static/img/404.bad10ac9.png";